const flexiblePricingConfig = {
  enabled: true,
  defaultValues: {
    adultHunter: {
      discount: 0, // 0% discount
      quantity: 1,
    },
    adultNonHunter: {
      discount: 75, // 75% discount
      quantity: 2,
    },
    youthHunter: {
      discount: 50, // 50% discount
      quantity: 2,
    },
    youthNonHunter: {
      discount: 100, // 100% discount (FREE)
      quantity: 2,
    },
  },
};

const LODGING_INFO = {
  REQUIRED: 'required',
  OPTIONAL: 'optional',
  NOT_OFFERED: 'Not Offered',
};

module.exports = { flexiblePricingConfig, LODGING_INFO };
